
import { isSSR } from '../isSSR';

// Calcola la distanza tra due punti usando la formula di Haversine
export const calculateDistance = (
  lat1: number, 
  lon1: number, 
  lat2: number, 
  lon2: number
): number => {
  if (isSSR()) return 0;

  const R = 6371; // Raggio della Terra in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distanza in km
  return distance;
};

// Converti gradi in radianti
const deg2rad = (deg: number): number => {
  return deg * (Math.PI / 180);
};

// Formatta la distanza in un formato leggibile
export const formatDistance = (distance: number): string => {
  if (isSSR()) return "N/A";
  
  if (distance < 1) {
    // Se la distanza è inferiore a 1km, mostra in metri
    return `${Math.round(distance * 1000)}m`;
  } else {
    // Altrimenti mostra in km con una cifra decimale
    return `${distance.toFixed(1)}km`;
  }
};
